import { commerceFacetSetReducer as commerceFacetSet } from '../facet-set/facet-set-slice.js';
import { toggleExcludeFacetValue, toggleSelectFacetValue, } from './regular-facet-actions.js';
/**
 * Loads the commerce facet set reducer and returns the available regular facet action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the regular facet action creators.
 *
 * @group Actions
 * @category RegularFacet
 */
export function loadRegularFacetActions(engine) {
    engine.addReducers({ commerceFacetSet });
    return {
        toggleExcludeFacetValue,
        toggleSelectFacetValue,
    };
}
